<app-slim-topbar *ngIf="guest"></app-slim-topbar>
<div class="layout-content p-0 mb-5 mt-3" [ngClass]="layoutMarginResponsive()">
	<div *ngIf="guest" class="flex align-items-center justify-content-center w-full font-semibold text-2xl my-3">
		{{'CALCULATION_POWER_PAGE_TITLE' | translate }}
	</div>
	<div class="card">
		<div class="flex align-items-center justify-content-center"
			[class]="onExtendedMobile() ? 'flex-column gap-2' : 'flex-row gap-3'">
			<div class="flex flex-column">
				<div [class]="onExtendedMobile() ? 'text-center' : 'text-center'">{{ 'BUS_SELECT_PANEL' | translate }}</div>
				<div class="flex flex-row align-items-center gap-4">
					<p-dropdown [options]="listBus" [(ngModel)]="busSelect" (onChange)="busChange()"
						styleClass="w-15rem h-2_5rem pl-6">
						<ng-template let-item pTemplate="selectedItem">
							<div class="item" class="flex align-items-center justify-content-center text-lg">
								<div class="flex justify-content-center">{{ item.name }}</div>
							</div>
						</ng-template>
						<ng-template let-item pTemplate="item">
							<div class="item flex align-items-center justify-content-center text-lg">
								<div>{{ item.name }}</div>
							</div>
						</ng-template>
					</p-dropdown>
				</div>
				<div [class]="onExtendedMobile() ? 'text-center' : 'text-center'">
					Potenza in standby: {{enableGreenPower?busSelect.powerGreen:busSelect.power}}W</div>
			</div>
			<!--<div class="flex flex-row align-items-center justify-content-center gap-2">
				<p-inputSwitch [(ngModel)]="enableGreenPower" (onChange)="busChange()" />
				<div class="pb-1">{{ "BUS_ENABLE_GREEN_POWER" | translate }}</div>
			</div>-->
		</div>

		<div *ngIf="maxGateway>0" class="grid mt-0">
			<!------------------ Gateway -->
			<div class="flex flex-column gap-3" [ngClass]="col3Responsive() + ' ' + customPaddingX()">
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_GATEWAY' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalGateway === maxGateway}">
						max: {{totalGateway}}/{{maxGateway}}
					</span>
				</div>
				<div class="flex flex-row align-items-center justify-content-between" *ngFor="let gateway of listGateway">
					<div class="flex flex-column justify-content-start">
						<span>{{ gateway.name | translate }}</span>
						<div class="text-sm" [class]="canAddAlertVisibleDevice(gateway)">Standby:{{gateway.powerGreen}}W
						</div>
					</div>
					<div class="flex flex-row align-items-center gap-2">
						<p-button pTooltip="{{ 'REMOVE' | translate}}"
							[disabled]="gateway.disableRemove || checkSelectable(gateway)" tooltipPosition="bottom"
							icon="pi cm-minus" size="large" (click)="subtractOne(gateway)" [rounded]="false" [text]="true"
							severity="primary">
						</p-button>
						<strong>{{ gateway.quantity }}</strong>
						<p-button pTooltip="{{ 'ADD' | translate}}"
							[disabled]="gateway.disableAdd || checkSelectable(gateway)" tooltipPosition="bottom"
							icon="pi cm-plus" size="large" (click)="addOne(gateway)" [rounded]="false" [text]="true"
							severity="primary">
						</p-button>
					</div>
				</div>
			</div>
			<!------------------ Schede -->
			<div *ngIf="maxSchede>0" class="flex flex-column gap-3" [ngClass]="col3Responsive() + ' ' + customPaddingX()">
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_SCHEDE' | translate }}</div>
					<span class="mr-4"></span>
				</div>
				<div class="flex flex-row align-items-center justify-content-between" *ngFor="let schede of listSchede">
					<div class="flex flex-column justify-content-start">
						<span>{{ schede.name | translate }}</span>
						<div class="text-sm" [class]="canAddAlertVisibleDevice(schede)">
							Standby:{{schede.powerGreen}}W</div>
					</div>
					<div class="flex flex-row align-items-center gap-2">
						<p-button pTooltip="{{ 'REMOVE' | translate }}"
							[disabled]="schede.disableRemove || checkSelectable(schede)" tooltipPosition="bottom"
							icon="pi cm-minus" size="large" (click)="subtractOne(schede)" [rounded]="false" [text]="true"
							severity="primary">
						</p-button>
						<strong>{{ schede.quantity }}</strong>
						<p-button pTooltip="{{ 'ADD' | translate }}" [disabled]="schede.disableAdd || checkSelectable(schede)"
							tooltipPosition="bottom" icon="pi cm-plus" size="large" (click)="addOne(schede)" [rounded]="false"
							[text]="true" severity="primary">
						</p-button>
					</div>
				</div>
			</div>
			<!------------------ Selettori -->
			<div *ngIf="maxSelettoriBus>0" class="flex flex-column gap-3"
				[ngClass]="col3Responsive() + ' ' + customPaddingX()">
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_SELECTORS_BUS' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalSelettoriBus === maxSelettoriBus}">max:
						{{totalSelettoriBus}}/{{maxSelettoriBus}}</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between"
						*ngFor="let selettore of listSelettoriBus">
						<div class="flex flex-column justify-content-start">
							<span>{{ selettore.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(selettore)">
								Standby:{{selettore.powerGreen}}W</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'REMOVE' | translate}}"
								[disabled]="selettore.disableRemove || checkSelectable(selettore)" tooltipPosition="bottom"
								icon="pi cm-minus" size="large" (click)="subtractOne(selettore)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
							<strong>{{ selettore.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="selettore.disableAdd || checkSelectable(selettore)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(selettore)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div>
			</div>
			<!-- COLL -->
			<div *ngIf="maxLampeggiantiBus>0 || maxInterfaccieBus>0 || maxFotocelluleBus>0" class="flex flex-column gap-3"
				[ngClass]="col3Responsive() + ' ' + customPaddingX()">
				<!------------------ Fotocellule -->
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_PHOTOCELLS_BUS' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalFotocelluleBus === maxFotocelluleBus}">max:
						{{totalFotocelluleBus}}/{{maxFotocelluleBus}}</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between"
						*ngFor="let fotocellula of listFotocelluleBus">
						<div class="flex flex-column justify-content-start">
							<span>{{ fotocellula.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(fotocellula)">
								Standby:{{fotocellula.powerGreen}}W</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'REMOVE' | translate}}"
								[disabled]="fotocellula.disableRemove || checkSelectable(fotocellula)" tooltipPosition="bottom"
								icon="pi cm-minus" size="large" (click)="subtractOne(fotocellula)" [rounded]="false"
								[text]="true" severity="primary">
							</p-button>
							<strong>{{ fotocellula.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="fotocellula.disableAdd || checkSelectable(fotocellula)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(fotocellula)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div>
				<!------------------ Interfaccie -->
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_INTERFACES_BUS' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalInterfaccieBus === maxInterfaccieBus}">max:
						{{totalInterfaccieBus}}/{{maxInterfaccieBus}}</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between"
						*ngFor="let interfaccia of listInterfaccieBus">
						<div class="flex flex-column justify-content-start">
							<span>{{ interfaccia.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(interfaccia)">
								Standby:{{interfaccia.powerGreen}}W</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'REMOVE' | translate}}"
								[disabled]="interfaccia.disableRemove || checkSelectable(interfaccia)" tooltipPosition="bottom"
								icon="pi cm-minus" size="large" (click)="subtractOne(interfaccia)" [rounded]="false"
								[text]="true" severity="primary">
							</p-button>
							<strong>{{ interfaccia.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="interfaccia.disableAdd || checkSelectable(interfaccia)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(interfaccia)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div><!------------------ Lampeggianti -->
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_FLASHING_BUS' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalLampeggiantiBus === maxLampeggiantiBus}">max:
						{{totalLampeggiantiBus}}/{{maxLampeggiantiBus}}</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between"
						*ngFor="let lampeggiante of listLampeggiantiBus">
						<div class="flex flex-column justify-content-start">
							<span>{{ lampeggiante.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(lampeggiante)">
								Standby:{{lampeggiante.powerGreen}}W</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'REMOVE' | translate}}"
								[disabled]="lampeggiante.disableRemove || checkSelectable(lampeggiante)"
								tooltipPosition="bottom" icon="pi cm-minus" size="large" (click)="subtractOne(lampeggiante)"
								[rounded]="false" [text]="true" severity="primary">
							</p-button>
							<strong>{{ lampeggiante.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="lampeggiante.disableAdd || checkSelectable(lampeggiante)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(lampeggiante)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div>
			</div>
			<!-- COLL -->
			<div *ngIf="maxFotocelluleOld>0 || maxSelettoriOld>0 || maxLampeggiantiOld>0" class="flex flex-column gap-3"
				[ngClass]="col3Responsive() + ' ' + customPaddingX()" style="height: 400px;">
				<!------------------ Selettori -->
				<div class="flex flex-row justify-content-between" *ngIf="maxSelettoriOld>0">
					<div class="font-semibold text-xl">{{ 'BUS_SELECTORS_OLD' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalSelettoriOld === maxSelettoriOld}">max:
						{{totalSelettoriOld}}/{{maxSelettoriOld}}</span>
				</div>
				<div class="flex flex-column gap-3" *ngIf="maxSelettoriOld>0">
					<div class="flex flex-row align-items-center justify-content-between gap-8"
						*ngFor="let selettori of listSelR">
						<div class="flex flex-column justify-content-start">
							<span>{{ selettori.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(selettori)">
								Standby:{{selettori.powerGreen}}W</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'REMOVE' | translate}}"
								[disabled]="selettori.disableRemove || checkSelectable(selettori)" tooltipPosition="bottom"
								icon="pi cm-minus" size="large" (click)="subtractOne(selettori)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
							<strong>{{ selettori.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="selettori.disableAdd || checkSelectable(selettori) || enabledAddWithBoard(selettori)"
								tooltipPosition="bottom" icon="pi cm-plus" size="large" (click)="addOne(selettori)"
								[rounded]="false" [text]="true" severity="primary">
							</p-button>
						</div>
					</div>
				</div>
				<!------------------ Fotocellule -->
				<div class="flex flex-row justify-content-between" *ngIf="maxFotocelluleOld>0">
					<div class="font-semibold text-xl">{{ 'BUS_PHOTOCELLS_OLD' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalFotocelluleOld === maxFotocelluleOld}">max:
						{{totalFotocelluleOld}}/{{maxFotocelluleOld}}</span>
				</div>
				<div class="flex flex-column gap-3" *ngIf="maxFotocelluleOld>0">
					<div class="flex flex-row align-items-center justify-content-between gap-8"
						*ngFor="let fotocellula of listFotocell">
						<div class="flex flex-column justify-content-start">
							<span>{{ fotocellula.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(fotocellula)">
								Standby:{{fotocellula.powerGreen}}W</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'REMOVE' | translate}}"
								[disabled]="fotocellula.disableRemove || checkSelectable(fotocellula)" tooltipPosition="bottom"
								icon="pi cm-minus" size="large" (click)="subtractOne(fotocellula)" [rounded]="false"
								[text]="true" severity="primary">
							</p-button>
							<strong>{{ fotocellula.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="fotocellula.disableAdd || checkSelectable(fotocellula)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(fotocellula)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div>
				<!------------------ Lampeggianti -->
				<div class="flex flex-row justify-content-between" *ngIf="maxLampeggiantiOld>0">
					<div class="font-semibold text-xl">{{ 'BUS_FLASHING_OLD' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalLampeggiantiOld === maxLampeggiantiOld}">max:
						{{totalLampeggiantiOld}}/{{maxLampeggiantiOld}}</span>
				</div>
				<div class="flex flex-column gap-3" *ngIf="maxLampeggiantiOld>0">
					<div class="flex flex-row align-items-center justify-content-between gap-8"
						*ngFor="let lampeggianti of listLampeggiantiOld">
						<div class="flex flex-column justify-content-start">
							<span>{{ lampeggianti.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(lampeggianti)">
								Standby:{{lampeggianti.powerGreen}}W</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'REMOVE' | translate}}"
								[disabled]="lampeggianti.disableRemove || checkSelectable(lampeggianti)"
								tooltipPosition="bottom" icon="pi cm-minus" size="large" (click)="subtractOne(lampeggianti)"
								[rounded]="false" [text]="true" severity="primary">
							</p-button>
							<strong>{{ lampeggianti.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="lampeggianti.disableAdd || checkSelectable(lampeggianti)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(lampeggianti)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div>
			</div><!-- COLL GRAPH -->
			<div class="flex flex-column gap-3" [ngClass]="calcCollGraph()+ ' '+ col3Responsive() + ' '">
				<div *ngIf="enableGreenPower" class="text-lg font-semibold {{statusLimitGreenPower===2?'text-50':''}}">
					Potenza Massima erogabile Modulo Green Power</div>
				<p-meterGroup [value]="valueGreenPower" *ngIf="enableGreenPower">
					<ng-template pTemplate="label">
					</ng-template>
					<ng-template pTemplate="start" let-totalPercent="totalPercent">
						<div class="flex justify-content-between relative">
							<span class="font-medium">0 W</span>
							<span style="border-left: 1px solid black;
									height: 32px; position: absolute; top: 20px;
									left: 0%;"></span>
							<span class="font-medium">MAX Watt</span>
							<span style="border-left: 1px solid black;
									height: 32px; position: absolute; top: 20px;
									left: 100%;"></span>
						</div>
					</ng-template>
				</p-meterGroup>
			</div>
		</div>

		<div class="grid mt-3">
			<!--<div [class]="col4Responsive()" class="flex justify-content-center">
				<div class="flex flex-column justify-content-center">
					<div class="flex flex-row align-items-center">
						<div class="w-11rem mr-2 text-xl font-semibold">{{ 'BUS_TOTAL_LOAD' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-xl font-semibold">(w)</div>
					</div>
					<div class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: black;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'BUS_PANEL' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalBoard}}</div>
					</div>
					<div *ngIf="maxGateway > 0" class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: red;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'GATEWAY' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadGateway}}</div>
					</div>
					<div *ngIf="maxSchede > 0" class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: purple;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'BUS_BOARD' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadSchede}}</div>
					</div>
					<div *ngIf="maxSelettoriBus > 0" class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: green;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'BUS_SELECTORS_BUS' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadSelettoriBus}}</div>
					</div>
					<div *ngIf="maxFotocelluleBus > 0" class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: orange;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'BUS_PHOTOCELLS_BUS' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadFotocelluleBus}}</div>
					</div>
					<div *ngIf="maxInterfaccieBus > 0" class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: blue;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'BUS_INTERFACES_BUS' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadInterfaccieBus}}</div>
					</div>
					<div *ngIf="maxLampeggiantiBus > 0" class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: pink;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'BUS_FLASHING_BUS' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadLampeggiantiBus}}</div>
					</div>
					<div *ngIf="maxSelettoriOld>0" class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: green;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'BUS_SELECTORS' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadSelettoriOld}}</div>
					</div>
					<div *ngIf="maxFotocelluleOld>0" class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: orange;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'BUS_PHOTOCELLS' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadFotocelluleOld}}</div>
					</div>
					<div class="flex flex-row align-items-center mt-3">
						<div class="w-11rem mr-2 text-xl font-semibold"> {{ 'BUS_TOTAL_POWER' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-xl font-semibold">{{totalPower}}</div>
					</div>
				</div>
			</div>-->
			<!-- <div [class]="overTablet() ? 'col-1' : ''"></div> -->
			<!--<div [class]="overTablet() ? 'col-3 col-offset-4' : onExtendedMobile() ? 'col-12' : 'col-12'"
				class="flex align-items-center justify-content-center">
				<div class="flex flex-column w-full gap-4">-->
			<!--<div class="flex justify-content-between" [class]="onExtendedMobile() ? 'flex-column' : 'flex-row'">
						<div class="flex flex-column gap-1" [class]="onExtendedMobile() ? 'text-center pb-3' : ''">
							<div class="text-lg font-semibold {{statusPowerNorm===2?'text-50':''}}" style="text-align: end;">
								Limite regolamento basso consumo
							</div>
							<div class="text-lg font-semibold {{statusPowerNorm===2?'text-50':''}} pt-1"
								style="text-align: end;">
								Consumo scheda in standby</div>
						</div>
						<p-meterGroup [value]="valueCalcPower" labelPosition="start">
							<ng-template pTemplate="label">
							</ng-template>
							<ng-template pTemplate="start" let-totalPercent="totalPercent">
								<div class="flex justify-content-between relative">
									<span></span>
									<span [style]="getColor(0.5)" style="width: 15%;" class="absolute text-right">0.5W</span>
									<span [style]="getColorBorder(0.5)" style="
									height: 32px; position: absolute; top: 20px;
									left: 10%;"></span>
									<span [style]="getColor(0.8)" style="width: 30%;" class="absolute text-right">0.8W</span>
									<span [style]="getColorBorder(0.8)" style="
									height: 32px; position: absolute; top: 20px;
									left: 25%;"></span>
									<span [style]="getColor(2)" style="width: 48%;" class="absolute text-right">2W</span>
									<span [style]="getColorBorder(2)" style="
									height: 32px; position: absolute; top: 20px;
									left: 45%;"></span>
									<span [style]="getColor(8)" style="width: 73%;" class="absolute text-right">8W</span>
									<span [style]="getColorBorder(8)" style="
									height: 32px; position: absolute; top: 20px;
									left: 70%;"></span>
									<span class="font-medium">40W</span>
									<span style="border-left: 1px solid black;
									height: 32px; position: absolute; top: 20px;
									left: 99%;"></span>
								</div>
							</ng-template>
						</p-meterGroup>
					</div>-->
			<!--	<div class="flex flex-column justify-content-center">
						<div *ngIf="enableGreenPower"
							class="text-lg font-semibold {{statusLimitGreenPower===2?'text-50':''}}">
							Potenza Massima erogabile Modulo Green Power</div>
						<p-meterGroup [value]="valueGreenPower" *ngIf="enableGreenPower">
							<ng-template pTemplate="label">
							</ng-template>
							<ng-template pTemplate="start" let-totalPercent="totalPercent">
								<div class="flex justify-content-between relative">
									<span class="font-medium">0 W</span>
									<span style="border-left: 1px solid black;
									height: 32px; position: absolute; top: 20px;
									left: 0%;"></span>
									<span class="font-medium">MAX Watt</span>
									<span style="border-left: 1px solid black;
									height: 32px; position: absolute; top: 20px;
									left: 99%;"></span>
								</div>
							</ng-template>
						</p-meterGroup>
					</div>
				</div>
			</div>-->
			<!--<div [class]="overTablet() ? 'col-2' : onExtendedMobile() ? 'col-12' : 'col-6'"
				class="flex align-items-center justify-content-center">
				<img src="assets/images/logos/GREEN-POWER.png" alt="Green Power enable" style="height:9rem;"
					*ngIf="statusPowerNorm===1" />
				<img src="assets/images/logos/GREEN POWER_Red.jpg" alt="Green Power disabled" style="height:9rem;"
					*ngIf="statusPowerNorm!==1" />
			</div>-->
			<!--<div [class]="overTablet() ? 'col-2' : onExtendedMobile() ? 'col-12' : 'col-6'"
				class="flex align-items-center justify-content-center">
				<div class="flex flex-column align-items-center justify-content-center">
					<div class="font-semibold text-lg">Regolamento basso consumo</div>
					<div class="font-normal text-sm" style="text-align: center;"><strong> 0.5W</strong>: Limite regolamento
						basso consumo</div>
					<div class="font-normal text-sm" style="text-align: center;"><strong> 0.8W</strong>: Limite regolamento
						basso consumo
						dispositivi con display</div>
					<div class="font-normal text-sm" style="text-align: center;"><strong> 2W</strong>: Limite regolamento
						basso consumo disp.
						no hina</div>
					<div class="font-normal text-sm" style="text-align: center;"><strong> 8W</strong>: Limite regolamento
						basso consumo disp.
						hina</div>
				</div>
			</div>-->
			<!--<div [class]="overTablet() ? 'col-3' : 'col-12'" *ngIf="busSelect.cxn > 0">
				<div class="flex flex-column align-items-center gap-3">
					<div class="flex w-full text-lg font-semibold {{ statusPowerBus===2 ? 'text-50' : ''}}"
						[ngClass]="onExtendedMobile() ? 'justify-content-center' : 'justify-content-center'">Potenza massima
						BUS
						{{busSelect.cxn}}W</div>
					<div class="flex">
						<p-chart #greenPower type="doughnut" [data]="totalChart" [options]="totalOptions" [responsive]="true"
							width="18rem">
							>
						</p-chart>
					</div>
				</div>
			</div>-->
		</div>
	</div>
</div>
<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<!--<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>-->
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>

<app-buscalculation-footer *ngIf="guest"></app-buscalculation-footer>